import React, { useEffect } from 'react';
import { CircularProgress, Box, Button } from '@mui/material';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';

const ChargingTimer = ({ secondsLeft, totalTime, setSecondsLeft, onAddTime, onDone }) => {
  console.log("ChargingTimer rendered with secondsLeft:", secondsLeft, "and totalTime:", totalTime);

  const formatTime = (secs) => {
    const m = Math.floor(secs / 60).toString().padStart(2, '0');
    const s = (secs % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  const percentage = (secondsLeft / totalTime) * 100 || 0;

  return (
    <div style={{ textAlign: 'center', width: "100%", display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2rem' }}>
      <h2 style={{ fontFamily: 'Mulish', fontWeight: 700, fontSize: '22px', color: '#000000' }}>
        Charging
      </h2>

      <Box position="relative" display="inline-flex">
        <CircularProgress
          variant="determinate"
          value={percentage}
          size={200}
          thickness={5}
          style={{ color: '#411363', backgroundColor: '#F5F5F5', borderRadius: '50%' }}
        />
        <Box
          position="absolute"
          top={0}
          left={0}
          bottom={0}
          right={0}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <BatteryChargingFullIcon style={{ fontSize: '32px', color: '#1B1A63' }} />
          <div style={{ fontSize: '20px', fontWeight: 600, fontFamily: 'Mulish', color: '#1B1A63' }}>
            {formatTime(secondsLeft)}
          </div>
        </Box>
      </Box>

      <div style={{ display: "flex", flexDirection: "column", width: "100%", gap: "1rem", marginTop: '2rem' }}>
        {secondsLeft <= 0 ? (
          <Button
            onClick={onDone}
            variant="outlined"
            style={{
              width: '100%',
              height: '56px',
              borderRadius: '16px',
              fontWeight: 600,
              fontFamily: 'Mulish',
              borderColor: '#261863',
              color: '#261863',
              borderWidth: '2px',
            }}
          >
            Done
          </Button>
        ) : null}

        <Button
          disabled
          variant="contained"
          style={{
            width: '100%',
            height: '56px',
            borderRadius: '16px',
            fontWeight: 600,
            fontFamily: 'Mulish',
            backgroundColor: '#261863',
            color: '#ffffff',
            opacity: 0.75,
          }}
        >
          Add Time — Coming soon
        </Button>
      </div>
    </div>
  );
};

export default ChargingTimer;
